module.exports = __webpack_public_path__ + "static/media/eoms-icon.858682bb.png";